import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../component/layout';
import { Link } from 'react-router-dom';
import { toastify } from '../../../utils/toast';
import { getItem } from '../../../utils/localStorage'
import { makeRequest2 } from '../../../utils/makeRequest';
import { getCampaignURL } from '../../../utils/urls';

const ViewCampaign = () => {
    const { campaignId } = useParams();
    const navigate = useNavigate();
    const [campaign, setCampaign] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredRecipients, setFilteredRecipients] = useState([]);

    const getCampaignById = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getCampaignURL}/${facilityId}/${campaignId}`, 'GET', {});
            console.log("c response", response);

            if (response.success) {
                const data = response.data;
                setCampaign(data);
                setFilteredRecipients(data.recipients || []);
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            toastify(err.message, 'error');
            return null;
        }
    };

    useEffect(() => {
        getCampaignById()
    }, [])

    useEffect(() => {
        if (campaign?.recipients) {
            const filtered = campaign.recipients.filter((r) => {
                const name = r.name?.toLowerCase() || '';
                const email = r.email?.toLowerCase() || '';
                const phone = r.phoneNumber || '';
                return (
                    name.includes(searchTerm.toLowerCase()) ||
                    email.includes(searchTerm.toLowerCase()) ||
                    phone.includes(searchTerm)
                );
            });

            setFilteredRecipients(filtered);
        }
    }, [searchTerm, campaign]);


    // Add loading state check
    if (!campaign) {
        return (
            <Layout>
                <div>
                    <div className="card">
                        <div className="card-header">
                            <Link to={"#"} onClick={() => navigate(-1)}><span><i className="ti ti-arrow-narrow-left"></i> Back</span></Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>View Campaign</h5>
                                </div>
                                <div className='card-body'>
                                    <div className="text-center">
                                        <p>Loading campaign details...</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div>
                <div className="card">
                    <div className="card-header">
                        <Link to={"#"} onClick={() => navigate(-1)}><span><i className="ti ti-arrow-narrow-left"></i> Back</span></Link>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>View Campaign</h5>
                                    </div>

                                    <div className="card-body p-0">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card border-0">
                                                    <div className="card-body p-4">

                                                        {/* Header Section */}
                                                        <div className="mb-4">
                                                            <h3 className="fw-bold mb-1">{campaign.name}</h3>
                                                            <div className="d-flex flex-wrap align-items-center gap-2">
                                                                <span className={`badge ${campaign.status === 'Completed' ? 'bg-success' : campaign.status === 'Pending' ? 'bg-warning text-dark' : campaign.status === 'Processing' ? 'bg-info text-dark' : 'bg-secondary'}`}>
                                                                    {campaign.status}
                                                                </span>
                                                                <span className={`badge ${campaign.campaignType === 'immediate' ? 'bg-primary' : campaign.campaignType === 'scheduled' ? 'bg-info text-dark' : 'bg-warning text-dark'}`}>
                                                                    {campaign.campaignType}
                                                                </span>
                                                                <small className="text-muted ms-2">
                                                                    Created: {new Date(campaign.createdAt).toLocaleDateString()}
                                                                </small>
                                                            </div>
                                                        </div>

                                                        <div className="row g-4">
                                                            {/* Left Column */}
                                                            <div className="col-md-6">

                                                                {/* Objective */}
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase text-muted small fw-bold">Objective</h6>
                                                                    <p className="mb-0">{campaign.objective}</p>
                                                                </div>

                                                                {/* Description */}
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase text-muted small fw-bold">Description</h6>
                                                                    <p className="mb-0">{campaign.description || <span className="text-muted">No description provided</span>}</p>
                                                                </div>

                                                                {/* Target Audience */}
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase text-muted small fw-bold">Target Audience</h6>
                                                                    <p className="mb-0">{campaign.targetAudience}</p>
                                                                </div>

                                                                {/* Schedule Section */}
                                                                {(campaign.campaignType === 'scheduled' || campaign.campaignType === 'recurring') && (
                                                                    <div className="mb-3">
                                                                        <h6 className="text-uppercase text-muted small fw-bold">Schedule Information</h6>
                                                                        {campaign.campaignType === 'scheduled' && campaign.scheduledDateTime && (
                                                                            <div className="p-3 bg-light rounded border">
                                                                                <strong>Scheduled for:</strong><br />
                                                                                {new Date(campaign.scheduledDateTime).toLocaleDateString()} at {new Date(campaign.scheduledDateTime).toLocaleTimeString()}
                                                                            </div>
                                                                        )}
                                                                        {campaign.campaignType === 'recurring' && campaign.scheduledDates?.length > 0 && (
                                                                            <div className="p-3 bg-light rounded border">
                                                                                <strong className="d-block mb-2">Recurring Schedule:</strong>
                                                                                {campaign.scheduledDates.map((schedule, index) => (
                                                                                    <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                                                                                        <span>{new Date(schedule.scheduledDateTime).toLocaleDateString()} at {schedule.time}</span>
                                                                                        <span className={`badge ${schedule.status === 'Completed' ? 'bg-success' : schedule.status === 'Pending' ? 'bg-warning text-dark' : 'bg-danger'}`}>
                                                                                            {schedule.status}
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Right Column */}
                                                            <div className="col-md-6">
                                                                {/* Channels */}
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase text-muted small fw-bold">Channels</h6>
                                                                    <div className="d-flex flex-wrap gap-2">
                                                                        {campaign.channels?.map((channel, i) => (
                                                                            <span key={i} className="badge bg-light text-dark border px-3 py-2">
                                                                                {channel}
                                                                            </span>
                                                                        )) || <span className="text-muted">N/A</span>}
                                                                    </div>
                                                                </div>

                                                                {/* Message */}
                                                                <div className="mb-3">
                                                                    <h6 className="text-uppercase text-muted small fw-bold">Message</h6>
                                                                    <div className="p-3 bg-light rounded border">
                                                                        {campaign.message}
                                                                    </div>
                                                                </div>

                                                                {/* Email Subject */}
                                                                {campaign.channels?.includes('Email') && campaign.emailSubject && (
                                                                    <div className="mb-3">
                                                                        <h6 className="text-uppercase text-muted small fw-bold">Email Subject</h6>
                                                                        <div className="p-3 bg-light rounded border">
                                                                            {campaign.emailSubject}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Recipients Section */}
                                                        {campaign.recipients?.length > 0 && (
                                                            <div className="mt-5">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h5 className="fw-semibold mb-0">Recipients</h5>
                                                                    <div className="col-md-4">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm p-2"
                                                                            placeholder="Search recipients..."
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover align-middle border">
                                                                        <thead className="bg-light">
                                                                            <tr>
                                                                                <th>Name</th>
                                                                                <th>Phone</th>
                                                                                <th>Email</th>
                                                                                <th>Sent Via</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {filteredRecipients.length > 0 ? (
                                                                                filteredRecipients.map((r, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>{r.name || 'N/A'}</td>
                                                                                        <td>{r.sentVia?.includes('SMS') && r.phoneNumber ? `254${r.phoneNumber}` : '...'}</td>
                                                                                        <td>{r.sentVia?.includes('Email') && r.email ? r.email : '...'}</td>
                                                                                        <td>
                                                                                            {r.sentVia?.map((method, i) => (
                                                                                                <span key={i} className="badge bg-info text-dark me-1">
                                                                                                    {method}
                                                                                                </span>
                                                                                            )) || 'N/A'}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="4" className="text-center text-muted">No records found</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ViewCampaign;